
export default {
    name: 'Checkbox',

    props: {
        initialValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        forId: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        isMultiline: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            checkboxStatus: this.initialValue,
        }
    },

    watch: {
        initialValue: function (val) {
            this.checkboxStatus = val
        },
    },

    methods: {
        handleChange() {
            const payload = {
                value: this.checkboxStatus,
            }
            if (this.forId) {
                payload.id = this.forId
            }

            this.$emit('checkboxUpdated', payload)
        },
    },
}
